import getSellingPlanId from "../helpers/getSellingPlanId";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";

class SectionWishlist extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector("[data-cart]");
    this.initFunction();
  }

  async addItemToCart(vp) {
    if (!vp) return;
    const response = await storefront.request({
      query: queries.variant,
      variables: {
        ids: encodeId(vp, "ProductVariant"),
      },
    });

    if (response)
      vp = response?.data?.nodes
        ? response?.data?.nodes?.filter((p) => p)[0]
        : vp;

    let id = vp?.id.toString().includes("gid") ? vp?.id.split("/") : vp?.id;
    id = id.length > 1 ? id[id.length - 1] : id;
    let available = vp.availableForSale || vp.available,
      quantity =
        (vp.inventoryQuantity && vp.inventoryQuantity > 0) ||
        (vp.quantityAvailable && vp.quantityAvailable > 0),
      inventoryReno = vp.inventoryReno?.value
        ? parseInt(vp.inventoryReno.value)
        : null,
      inventoryAtlanta = vp.inventoryAtlanta?.value
        ? parseInt(vp.inventoryAtlanta.value)
        : null;

    quantity = !inventoryReno && !inventoryAtlanta ? false : quantity;
    let oos = vp?.oosMessage?.value ? vp?.oosMessage?.value : "";

    oos = oos ? oos : "Briefly out of stock, ships soon";

    const properties = {
      _inventoryReno: inventoryReno,
      _inventoryAtlanta: inventoryAtlanta,
      _selling_plan: getSellingPlanId(vp),
      _added_by: 'wishlist',
    };

    window.addToCart({
      id: id,
      quantity: 1,
      properties,
      selling_plan: getSellingPlanId(vp),
    });
  }

  initFunction() {
    window.addEventListener("click", (event) => {
      if (event.target.hasAttribute("data-wk-add-to-cart")) {
        event.preventDefault();
        const product = event.target.dataset.shopifyId;
        this.addItemToCart([product]);
      }

      if (
        event.target.classList.contains("wk-product-form__option__radio-input")
      ) {
        const wishId = event.target.dataset.wkIdentifier;
        const wishInput = document.querySelector(
          `input.secret[data-wk-identifier="${wishId}"]`
        );
        setTimeout(() => {
          const shopId = wishInput.value;
          const quickButton = document.querySelector(
            `.wk-quick-add[data-wk-identifier="${wishId}"]`
          );
          const quickLink = quickButton.querySelector(".wk-product-quick-link");
          quickLink.dataset.shopifyId = shopId;
        }, 500);
      }
    });
  }
}

if (!customElements.get("section-wishlist")) {
  customElements.define("section-wishlist", SectionWishlist);
}
